var map = {
	"./sec-1-ar.png": 1164,
	"./sec-1-en.png": 1165,
	"./sec-2.png": 1166,
	"./sec-3-ar.png": 1167,
	"./sec-3-en.png": 1168,
	"./sec-4.png": 1169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1163;